export const minecraft1210 = {
  version: '1.21',
  title: 'Tricky Trials',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Vanilla-PMP_Collection-Carousel-0_Tricky-Trials_1280x768.jpg',
  releases: [
    {
      id: "150kB4Zym",
      version: "1.0.4",
      date: "Jul 5, 2025",
      changelog: "Versión estable para Minecraft 1.21 con todos los mods optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    }
  ]
};